˝<template>
  <div id="profit-box">
    <div class="nav">
      <img src="../../assets/nav/yz_nav_fh.png" class="fh" @click="goBack" />
      <p>收益明细</p>
      <div class="right-nr">
        <div class="text"></div>
      </div>
    </div>

    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="(item, i) in state.profitList" :key="i + '-list'">
        <template #value>
          <span>{{ item.key }}</span>
          <ul class="profit-data">
            <li v-for="data in item.items" :key="data.id">
              <p v-if="data.user_login">{{ data.user_login.slice(0, 3) }}***</p>
              <p v-else-if="data.mobile">
                {{
                  data.mobile.slice(0, 3) + "****" + data.mobile.slice(7, 11)
                }}
              </p>

              <p>充值时间：{{ data.ordertime }}</p>
              <p>+{{ data.settlement_user_amount }}</p>
              <span>
                <button
                  class="btn"
                  @click="receiveGift(data.id)"
                  v-if="data.settle == '0'"
                >
                  领取
                </button>
                <button v-else class="btnT">
                  已领取
                </button>
              </span>
            </li>
          </ul>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { onActivated, onMounted, reactive } from "vue";
import { profitDetail, receiveDetail } from "../../api/yzuser.js";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
export default {
  name: "profitDetail",
  setup() {
    const state = reactive({
      btnFlag: true,
      profitList: [],
      getted: [],
      loading: false,
      finished: false,
      oldProfitList: [],
    });
    // 领取礼包
    const receiveGift = (id) => {
      // 将已领取的id存入数组
      // console.log('点击的行数',id)
      // state.getted.push(id)

      let val = {
        uid: getQueryString("uid"),
        // uid: localStorage.getItem('uid'),
        id: id,
      };
      // console.log(val)
      receiveDetail(val).then((response) => {
        state.btnFlag = !state.btnFlag;
        console.log(response);
        if (response.data.code == 1) {
          window.location.reload();
          Toast("领取成功");
        }
      });
    };

    onMounted(async () => {
      onLoad();
    });
    const goBack = () => {
      window.history.go(-1);
    };

    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      state.uid = localStorage.getItem("uid");
      let val = {
        // uid: state.uid,
        uid: getQueryString("uid"),
        pagecode: pagecode,
      };
      profitDetail(val).then((response) => {
        // console.log(response)
        // 存放原始数据
        state.oldProfitList = state.oldProfitList.concat(
          response.data.data.lists
        );
        // 除去id相同的数据
        state.oldProfitList = state.oldProfitList.reduce((prev, cur) => {
          let hasCur = prev.some((item) => item.id === cur.id);
          return hasCur ? prev : [...prev, cur];
        }, []);

        if (response.data.code == 1) {
          totalpage = response.data.data.total_page;

          state.profitList = response.data.data.lists;
          let month = state.oldProfitList;

          let groupDate = month.reduce((groups, item) => {
            let date = new Date(item.ordertime);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let ym = "" + year + "年" + month + "月";
            if (!groups[ym]) {
              groups[ym] = [];
            }
            groups[ym].push(item);
            return groups;
          }, {});

          const groupedArray = Object.entries(groupDate).map(([key, items]) => {
            return { key, items };
          });

          // 存放处理过后的数据
          state.profitList = groupedArray;

          console.log(groupedArray);
        } else {
          Toast(response.data.msg);
          state.finished = true;
        }
        // console.log(pagecode)
        pagecode++;
        if (pagecode > totalpage) {
          state.finished = true;
          return;
        }
        state.loading = false;
      });
    };

    return {
      state,
      receiveGift,
      goBack,
      onLoad,
    };
  },
};
</script>
<style scoped>
#profit-box {
  width: 100%;
  /* height: 100%; */
  min-height: 100vh;
  background-color: #f7f8fa;
  /* padding: 32px; */
  /* padding-top: 160px; */
  padding-top: 58px;
}

#profit-box .profit-data li {
  box-sizing: border-box;
  height: 126px;
  background-color: #fff;
  margin-bottom: 20px;
  border-radius: 16px;
  padding-left: 24px;
  padding-top: 20px;
  padding-bottom: 20px;
  position: relative;
}

#profit-box li span {
  display: block;
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 20px;
}
.profit-data .btn,
.btnT {
  height: 40px;
  width: 100px;
  border: 0;
  border-radius: 20px;
  color: #fff;
  background-color: #12cec7;
  position: absolute;
  right: 20px;
  bottom: 42px;
}
.profit-data .btnT {
  background-color: #e6e6e6;
}
.profit-data li p:nth-of-type(1) {
  margin-bottom: 12px;
  font-size: 28px;
  font-weight: 500;
}

.profit-data li p:nth-of-type(2) {
  font-size: 20px;
  color: #707070;
}
.profit-data li p:nth-of-type(3) {
  font-size: 20px;
  color: #ff6666;
  position: absolute;
  right: 152px;
  bottom: 42px;
  font-size: 28px;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 88px;
  width: 100%;
  position: sticky;
  top: 50px;
  z-index: 999;
  padding: 0 20px;
}
.nav .text {
  font-size: 30px;
  color: #664fc3;
}

.nav img {
  height: 50px;
  width: 50px;
  position: absolute;
  left: 20px;
}
.nav p {
  font-size: 32px;
  font-weight: 500;
  color: #333;
}

.van-cell {
  background-color: #f7f8fa;
}
.van-cell__value span {
  display: block;
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #fff;
}

.van-cell__value li {
  margin-bottom: 12px;
  font-size: 28px;
  font-weight: 500;
  background-color: #fff;
  height: 120px;
  border-radius: 16px;
  padding: 20px 24px;
}
.van-cell__value li p:nth-of-type(1) {
  font-size: 28px;
  font-weight: 500;
  color: #333;
}
.van-cell__value li p:nth-of-type(2) {
  font-size: 20px;
  color: #333;
}
</style>
